<template>
    <v-container style="background-color: #fff">
        <v-progress-linear  v-if="utility.dataLoading" color="blue" value="50" indeterminate></v-progress-linear>
        <v-layout>
            <v-card width="100%" flat>
                <v-form v-model="regReportFormValid">
                    <v-container class="px-1">
                        <v-flex offset-lg1 offset-md2 offset-xs0 lg10 md8 xs12 align-center justify-space-between>
                            <v-card-title v-if="reportId" primary-title class="py-4 title">
                                Редактировать отчет "{{reportId}}"
                            </v-card-title>
                            <v-card-title v-else primary-title class="py-4 title">
                                Зарегистрировать отчет
                            </v-card-title>

                            <v-container v-if="utility.completed">
                                <v-flex xs12 md12 style="text-align: center">
                                    <div style="font-size:24px">Успешно сохранено</div>
                                    <v-btn v-if="inModal" large color="primary"
                                           v-on:click="$emit('close-dlg')">Закрыть
                                    </v-btn>
                                    <v-btn v-if="!inModal" large color="primary"
                                           @click="restart()">Зарегистрировать еще отчет
                                    </v-btn>

                                </v-flex>
                            </v-container>
                            <v-container v-else>
                                <v-layout v-if="!inModal">
                                    <v-flex xs12 md12 style="text-align: center">
                                        Введите код теста, данные отчета, идентификатор отчета
                                        (или он будет сформирован автоматически). Заголовок будет использоваться только
                                        в списках.
                                        <i><br> Будьте осторожны - большой размер JSON данных вызывает временное
                                            подвисание,
                                            поскольку проверка валидности происходит на лету</i>

                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field prepend-icon="vpn_key" name="reg_report_test" class="notranslate"
                                                      label="Код теста (6 последних букв/цифр)"
                                                      v-model="regReport.testId"
                                                      mask="NNNNNN"
                                                      :rules="[rules.required]"
                                                      type="text"
                                                      required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="false">
                                        <v-text-field prepend-icon="lock_open" name="reg_report_id" class="notranslate"
                                                      label="Id отчета (необязательно)" v-model="regReport.reportId"
                                                      type="text"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field prepend-icon="title" name="reg_report_title" class="notranslate"
                                                      label="Заголовок" v-model="regReport.title"
                                                      type="text"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field prepend-icon="dashboard" name="reg_report_template" class="notranslate"
                                                      label="Шаблон" v-model="regReport.template"
                                                      :rules="[rules.required]"
                                                      type="text"
                                                      required></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field prepend-icon="attach_file" name="reg_report_datafile" class="notranslate"
                                                      label="Путь к файлу от корня сервера" v-model="regReport.dataFile"
                                                      type="text"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea prepend-icon="archive" name="reg_report_data" class="notranslate"
                                                    label="Данные отчета" v-model="regReport.data"
                                                    :rules="[rules.isValidJson]"
                                                    type="text"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-switch prepend-icon="done" class="notranslate"
                                                  :label="`Отчет ${regReport.isReady? '':'не '} готов`"
                                                  v-model="regReport.isReady"
                                        ></v-switch>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6>
                                        <v-btn block large color="primary" v-if="reportId"
                                               :disabled="!regReportFormValid"
                                               @click="updateReport">Сохранить
                                        </v-btn>
                                        <v-btn block large color="primary" v-else :disabled="!regReportFormValid"
                                               @click="registerReport">Зарегистрировать
                                        </v-btn>
                                    </v-flex>
                                    <v-flex v-if="inModal" xs12 offset-sm1 sm5 md5>
                                        <v-btn large block
                                               v-on:click="$emit('close-dlg')">Закрыть
                                        </v-btn>
                                    </v-flex>

                                </v-layout>
                            </v-container>

                        </v-flex>
                    </v-container>
                </v-form>


            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "RegReport",
        props: ['reportId', 'inModal'],

        data: () => ({
            regReportFormValid: false,
            regReportFormIsDirty: false,
            regReport: {
                testId: "",
                reportId: "",
                title: "",
                data: "",
                dataFile: "",
                isReady: false,
                template: "generic"
            },
            utility: {
                dataLoading: false,
                completed: false
            },
            rules: {
                required: value => !!value || 'Required.',
                isValidJson: value => {
                    if (!value) return false;
                    try {
                        if (JSON.parse(value)) return false;
                    }
                    catch {
                        return 'Not valid JSON.';
                    }
                    return 'Not valid JSON.';
                },
                counter: value => value.length <= 20 || 'Max 20 characters'
            }
        }),
        methods: {
            restart: function () {
                this.regReport = {
                    testId: "",
                    reportId: "",
                    title: "",
                    data: "",
                    dataFile: "",
                    isReady: false,
                    template: "generic"
                }
                this.utility.completed = false
            },
            registerReport: function () {
                var this_ = this;

                var output = {}
                Object.assign(output, this.regReport)
                if (output.data) output.data = JSON.parse(this.regReport.data)
                if (!output.reportId) output.reportId = output.testId + (Math.floor(+new Date() / 1000))

                this.$store.dispatch('regReport', output).then(function (response) {
                    this_.response = response
                    if (this_.response.status === 200) this_.utility.completed = true
                    else this_.$store.dispatch('processError', this_.response)
                })
            },
            updateReport: function () {
                var this_ = this;

                var output = {}
                Object.assign(output, this.regReport)
                if (output.data) output.data = JSON.parse(this.regReport.data)
                if (!output.reportId) output.reportId = output.testId + (Math.floor(+new Date() / 1000))

                this.$store.dispatch('adminReportSet', output).then(function (response) {
                    this_.response = response

                    if (this_.response.status === 200) {
                        if (this_.inModal) {
                            this_.$emit('close-dlg')
                            this_.$emit('reload-list')
                        }
                        else this_.utility.completed = true
                    }

                    this_.$store.dispatch('processError', this_.response)
                })
            },
            loadReport: function () {
                var this_ = this;
                this_.utility.completed = false
                this_.utility.dataLoading = true
                this.$store.dispatch('adminReportGet', {reportId: this.reportId}).then(function (response) {
                    this_.response = response
                    this_.$store.dispatch('processError', this_.response)
                    if (this_.response.status === 200) {
                        this_.regReport = this_.response.data.report
                    }
                    this_.utility.dataLoading = false
                })
            },

        },
        watch: {
            reportId: function () {
                if (this.reportId) {
                    this.loadReport()
                }
                else {
                    this.regReport = {
                        testId: "",
                        reportId: "",
                        title: "",
                        data: "",
                        dataFile: "",
                        isReady: false,
                        template: "generic"
                    }
                }
            }
        },
        computed: {
            profileFormCanSave: function () {
                if (this.regReportFormValid) return true;
                return false;
            }
        },
        created: function () {
            if (this.reportId) {
                this.loadReport()
            }
        }

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
</style>